import DataStorage from '../_utils/DataStorage';

const SESSION_KEY = 'intro-is-disabled';

export default class Intro {


	// Constructor
	constructor(callback) {
		this.callback = callback;
		this.element = document.getElementById('intro');

		let isDisabled = DataStorage.getSessionItem(SESSION_KEY);
		if (!this.element) {
			isDisabled = true;
		}
		DataStorage.setSessionItem(SESSION_KEY, true);

		if (isDisabled) {
			this.cleanUp();
			// this.fadeIn();
			this.callback();
			this.destroy();
			return;
		}

		this.buttonClick = this.buttonClick.bind(this);
		this.imageLoaded = this.imageLoaded.bind(this);
		this.skip = this.skip.bind(this);
		this.done = this.done.bind(this);


		this.button = this.element.querySelector('button');
		this.imageCache = [];
		this.imageCount = 0;
		this.images = Array.prototype.slice.call(this.element.querySelectorAll('img'), 0);
		this.timer = null;

		document.body.classList.add('has-intro');
		window.scrollTo(0, 0);

		let i, l, img;
		for (i=0, l=this.images.length; i<l; i++) {
			img = new Image();
			this.imageCache.push(img);
			img.onload = this.imageLoaded;
			img.src = this.images[i].src;
		}
	}


	// Private Methods
	cleanUp() {
		if (this.element) {
			this.element.parentNode.removeChild(this.element);
		}
	}
	destroy() {
		delete this.callback;
		delete this.element;
		if (this.button) {
			delete this.button;
			delete this.imageCache;
			delete this.imageCount;
			delete this.images;
			delete this.timer;
		}
		document.body.classList.remove('intro-play');
		document.body.classList.remove('intro-skip');
	}
	fadeIn() {
		const fadeIn = document.querySelector('.fade-in');
		fadeIn.classList.add('play');
		setTimeout(() => {
			fadeIn.parentNode.removeChild(fadeIn);
		}, 600);
	}


	// Event Handlers
	buttonClick(event) {
		event.preventDefault();
		this.skip();
	}
	imageLoaded() {
		this.imageCount ++;
		if (this.imageCount >= this.images.length) {
			this.loadHeroImage();
			this.button.addEventListener('click', this.buttonClick);
			this.fadeIn();
			document.body.classList.add('intro-play');
			this.timer = setTimeout(this.skip, 8700);
		}
	}
	loadHeroImage() {
		const image = document.querySelector('.section-hero-home--img img');
		if (image) {
			let src = image.getAttribute('data-src');
			if (src) {
				const srcMobile = image.getAttribute('data-src-mobile');
				if (srcMobile && window.innerWidth < 768) {
					src = srcMobile;
				}
				image.removeAttribute('data-src');
				image.removeAttribute('data-src-mobile');
				image.setAttribute('src', src);
			}
		}
	}
	skip() {
		clearTimeout(this.timer);
		this.button.removeEventListener('click', this.buttonClick);
		document.body.classList.add('intro-skip');
		this.timer = setTimeout(this.done, 600);
	}
	done() {
		this.cleanUp();
		this.callback();
		this.destroy();
	}


}
